import { render, staticRenderFns } from "./pagenations.vue?vue&type=template&id=25f1ef16&"
import script from "./pagenations.vue?vue&type=script&lang=js&"
export * from "./pagenations.vue?vue&type=script&lang=js&"
import style0 from "./pagenations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports